
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files directly (bundling them for now)
import commonEn from './locales/en/common.json';
import commonEl from './locales/el/common.json';
import dashboardEn from './locales/en/dashboard.json';
import dashboardEl from './locales/el/dashboard.json';
import authEn from './locales/en/auth.json';
import authEl from './locales/el/auth.json';
import biEn from './locales/en/bi.json';
import biEl from './locales/el/bi.json';
import settingsEn from './locales/en/settings.json';
import settingsEl from './locales/el/settings.json';
import documentsEn from './locales/en/documents.json';
import documentsEl from './locales/el/documents.json';
import billingEn from './locales/en/billing.json';
import billingEl from './locales/el/billing.json';

// We will add more files here as we extract them
const resources = {
    en: {
        common: commonEn,
        dashboard: dashboardEn,
        auth: authEn,
        bi: biEn,
        settings: settingsEn,
        documents: documentsEn,
        billing: billingEn,
    },
    el: {
        common: commonEl,
        dashboard: dashboardEl,
        auth: authEl,
        bi: biEl,
        settings: settingsEl,
        documents: documentsEl,
        billing: billingEl,
    },
};

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        resources,
        fallbackLng: 'en',
        debug: import.meta.env.DEV, // Enable debug in dev mode

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },

        // Namespace configuration
        defaultNS: 'common',
        ns: ['common', 'dashboard', 'auth', 'bi', 'settings', 'documents', 'billing'],

        // Handle regional locales (e.g. el-GR -> el)
        load: 'languageOnly',
        supportedLngs: ['en', 'el'],
        nonExplicitSupportedLngs: true, // allows el-GR to be supported if el is supported
    });

// Update HTML lang attribute (crucial for Greek uppercase accent removal)
i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
});

export default i18n;
